import { currentPath } from '@/features/router/router.state.js'
import { effect } from '@core/signal.js'

const EXCLUDED = ['/admin', '/registrar']

function shouldTrack(path) {
    return !EXCLUDED.some(p => path === p || path.startsWith(p + '/'))
}

export function initAnalytics() {
    effect(() => {
        const path = currentPath.get()
        if (typeof window.gtag === 'function' && shouldTrack(path)) {
            window.gtag('event', 'page_view', { page_path: path })
        }
    })
}
